import { PageResearchStudies } from './PageResearchStudies';

export default PageResearchStudies;
